require.context("../images", true);
import "stylesheets/decidim/conferences/conferences.scss";
